

































































import Vue from 'vue';
import { Getter } from 'vuex-class';
import Component, { mixins } from 'vue-class-component';
import _ from 'lodash';
import { mdiChevronRight } from '@mdi/js';
import { InfosPSBEN } from '@/store/infosPSBEN/types';
import { InjectionType, VaccinationFolder, PrescriptionType } from '@/store/folder/types';
import { ParametresUtilisateur } from '@/store/parametresUtilisateur/types';
import { InjectionCycleType } from '@/components/SuiviVaccinations/TableauVaccinations/types';
import { PopinDelAvailable } from '@/components/PopinsRecapitulatif';
import PopInReopenCycle from '@/components/BandeauCycle/PopinBandeauCycle/PopInReopenCycle.vue';
import PdfTransmission from '@/mixins/PdfTransmission';
import dayjs from 'dayjs';

const Props = Vue.extend({
	props: {
		item: {
			type: Object as () => InjectionCycleType,
			default: null
		}
	}
});

@Component({
	components: {
		PopinDelAvailable,
		PopInReopenCycle
	}
})
export default class VaccinationTableBtns extends mixins(Props, PdfTransmission) {
	@Getter('infosPSBEN/getInfosPSBEN') getInfosPSBEN!: InfosPSBEN | undefined;
	@Getter('parametresUtilisateur/getParametresUtilisateur') parametresUtilisateur!: Map<string, ParametresUtilisateur>;
	@Getter('infosVaccinationFolder/getInjections') injections!: InjectionType[] | undefined;
	@Getter('infosVaccinationFolder/getVaccinationFolder') vaccinationFolder!: VaccinationFolder | undefined;
	@Getter('infosVaccinationFolder/getPrescription') getPrescription!: PrescriptionType | undefined;
	@Getter('infosVaccinationFolder/getDeletionEnabled') isDeletionEnabled!: boolean | undefined;
	@Getter('infosVaccinationFolder/getReactivationAvailable') reactivationAvailable!: boolean;
	@Getter('infosVaccinationFolder/getIsLastCycle') isLastCycleNotCancel!: boolean;

	chevronRight = mdiChevronRight;
	popinDelAvailable = false;
	popinReopenCycle = false;

	hasState(state: string): boolean {
		return _.get(this.getPrescription, 'etatDossierVacc') === state;
	}

	get psIsEnregistreur() {
		const psNumRPPS = _.get(this.getInfosPSBEN, 'ps.numRPPS');
		const enregistreurNumRPPS = _.get(this.injection, 'vaccinateur.rpps');
		return (_.isEmpty(psNumRPPS) && _.isEmpty(enregistreurNumRPPS)) || _.isEqual(psNumRPPS, enregistreurNumRPPS);
	}

	injectionByRang(rang: number): InjectionType | undefined {
		return _.find(_.get(this.getPrescription, 'injections'), { rangVaccinal: rang });
	}

	get injection(): InjectionType | undefined {
		if (!_.isNil(this.item.injection)) {
			return this.injectionByRang(this.item.injection!.rangVaccinal);
		} else {
			return undefined;
		}
	}

	get hasNoFurtherInjection(): boolean {
		return !_.isNil(this.item.injection) && this.injectionByRang(this.item.injection!.rangVaccinal + 1) === undefined;
	}

	get editable(): boolean {
		return !this.hasState('AN') && this.psIsEnregistreur && this.hasNoFurtherInjection;
	}

	get deletable(): boolean {
		const dateInjection = dayjs(_.get(this.injection, 'horodatageEnregistrement'));
		return this.editable &&
			dayjs().startOf('day').isBefore(dateInjection) &&
			dayjs().endOf('day').isAfter(dateInjection);
	}

	get printable(): boolean {
		return !this.hasState('AN') && this.isLastCycleNotCancel;
	}

	deleteInjectionPopup(): void {
		if (this.deletable) {
			this.popinDelAvailable = true;
		}
	}

	downloadPdfVaccination() {
		if (this.vaccinationFolder && this.injections && !_.isNil(this.item.injection)) {
				const parametresUtilisateur =
					this.parametresUtilisateur.get(_.get(this.getInfosPSBEN, 'ps.numRPPS')) as ParametresUtilisateur;
				const psDelegation = _.get(parametresUtilisateur, 'delegation');
				this.openVaccinationPdf(
					this.vaccinationFolder, this.item.injection!.rangVaccinal, this.injections, psDelegation
				);
		}
	}

	isLastCloture() {
		return _.last(this.getPrescription?.clotureReprises) === this.item.cloture;
	}

	get hasReopenButton(): boolean {
		const isLastCycleClotureAndNotCancel: boolean = this.isLastCycleNotCancel && this.isLastCloture();
		const isPrescriptionTE: boolean = !_.isNil(this.getPrescription)
			&& this.getPrescription.injections?.length < 2 && this.hasState('TE');
		const isItemCloture: boolean = !_.isNil(this.item.cloture)
			&& this.item.cloture!.action === 'CLOTURE';
		return isLastCycleClotureAndNotCancel && isPrescriptionTE && isItemCloture;
	}

	get getNumeroBon(): string | undefined {
		return _.get(this.vaccinationFolder, 'numeroBon');
	}

}
